export default "__VITE_ASSET__Cmb52oet__"